module.exports = __webpack_public_path__ + "static/media/fabio-mangione.8380be7d.jpg";